export interface IDocumentsData {
  description: string;
}

export interface IFilterRegisterActive {
  orderBy: string;
  ascend: string;
  itemsByPage: number;
  pageIndex: number;
}

export type IItems = {
  id: number;
  description: string;
};

export interface IEditDocument {
  documentId: number;
  description: string;
  maskRules: {
    maskAllowLetters: boolean;
    maskAllowNumbers: boolean;
    maskAllowSpecialCharacters: boolean;
    maskMinCharacters: number;
    maskMaxCharacters: number;
  };
}

export interface IDocumentState {
  isLoading: boolean;
  isLoadingTable: boolean;
  disabledButton: boolean;
  items?: Array<IItems>;
  totalItems: number;
  filter: IFilterRegisterActive;
  visibleDrawerNewDocument: boolean;
  visibleDrawerEditDocument: boolean;
  editDocument: IEditDocument;
  searchFilter?: string;
  maskAllowLetters: boolean;
  maskAllowNumbers: boolean;
  maskAllowSpecialCharacters: boolean;
  maskMinCharacters: number;
  maskMaxCharacters: number;
  formEditModified: boolean;
}

export const defaultState: IDocumentState = {
  isLoading: false,
  isLoadingTable: false,
  visibleDrawerNewDocument: false,
  visibleDrawerEditDocument: false,
  formEditModified: false,
  disabledButton: false,
  items: [],
  totalItems: 0,
  searchFilter: "",
  maskAllowLetters: true,
  maskAllowNumbers: true,
  maskAllowSpecialCharacters: true,
  maskMinCharacters: 0,
  maskMaxCharacters: 100,
  editDocument: null,
  filter: {
    orderBy: "",
    ascend: "",
    itemsByPage: 10,
    pageIndex: 1,
  },
};
